import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { FC, useEffect } from 'react';
import { useApptRequestsWidget } from '../../hooks/use-appt-requests-widget';
import { ApptRequestsWidgetRoutePath } from '../../navigation/route-config';
import { AppliedFilters } from '../filters/applied-filters';
import { FilterButton } from '../filters/filter-button';
import { Page, PageContent, PageTitle } from '../styles';
import { ApptRequestList } from './appt-request-list/appt-request-list';
import { ApptRequestsViewSkeleton } from './appt-requests.skeleton';
import { ApptRequestsTitle } from './appt-requests.styles';

export const ApptRequestsView: FC = () => {
  const { publishToIframes } = useEventBus();
  const { goTo, isLoading } = useApptRequestsWidget();

  useEffect(() => {
    publishToIframes({ messageType: 'appt-request-reset' });
  }, []);

  const handleFilterClick = () => {
    goTo({ path: ApptRequestsWidgetRoutePath.FILTERS });
  };

  if (isLoading) return <ApptRequestsViewSkeleton />;

  return (
    <Page>
      <PageTitle sx={{ flexDirection: 'column' }}>
        <ApptRequestsTitle>
          Scheduling Alerts
          <FilterButton onClick={handleFilterClick} />
        </ApptRequestsTitle>
        <AppliedFilters />
      </PageTitle>
      <PageContent sx={{ margin: '0 0 20px 0' }}>
        <ApptRequestList />
      </PageContent>
    </Page>
  );
};
